import React, { useState, useEffect } from "react";
import "./LoadingScreen.css";
import Loader from "../shared/Loader";

const LoadingScreen = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + Math.random() * 15;
      });
    }, 200);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="app">
      <div className="loading-screen">
        <Loader />
      </div>
    </div>
  );
};

export default LoadingScreen;
